import { useQuery } from '@apollo/client';
import { Stack, useTheme } from '@fluentui/react';
import { useId } from '@fluentui/react-hooks';
import { Handle, Position, useReactFlow } from '@xyflow/react';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { ApprovalSetupFlowCommonData } from 'settings/account/intuitiveApprovalSetupFlow/__generated__/ApprovalSetupFlowCommonData';
import { ApprovalValues, RequestorConditionsValues } from '../../../types';
import { movingNodeId } from '../../ApproverLevels';
import { setNodeScrollState } from '../../Conditions';
import { Add } from '../common/Add';
import { FormView } from './FormView';
import APPROVAL_TYPE_DATA from '../../../../ApprovalSetupFlowCommonData.graphql';

// @ts-ignore
export const AddConditionNode: React.FC = ({ data, isConnectable }) => {
  const calloutId = useId(`AddConditionNode-callOutId`);
  const [visibility, setVisibility] = useState(false);
  const { getValues, setValue } = useFormContext<ApprovalValues>();

  // Nodes and Edges
  const { getNodes } = useReactFlow();
  const currentNodes = getNodes();

  const { data: approvalTypes } = useQuery<ApprovalSetupFlowCommonData>(
    APPROVAL_TYPE_DATA,
    {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only',
      nextFetchPolicy: 'cache-only',
    }
  );

  const handleAddCondition = (data: RequestorConditionsValues) => {
    // Identify the current last node (which is the AddConditionNode)

    const prevNode = currentNodes[currentNodes.length - 2];
    const prevImportanceLevel = prevNode.data.importanceLevel as number;
    const importanceLevel =
      currentNodes.length > 2 ? prevImportanceLevel + 1 : 1;
    const conditions = getValues('approvalSelectionConditions') || [];
    const updatedConditions = [
      ...conditions.slice(0, -1),
      {
        ...data,
        isAndCondition: data.isAndCondition ?? false,
        importanceLevel,
      },
      { ...conditions[conditions.length - 1] },
    ];
    setValue('approvalSelectionConditions', updatedConditions, {
      shouldDirty: true,
    });
    setNodeScrollState(true);
    setVisibility(false); // optionally close the Callout
  };
  const movingNode = movingNodeId();

  return (
    <Stack style={{ opacity: movingNode && movingNode !== data.id ? 0.5 : 1 }}>
      <Handle
        type="target"
        position={Position.Top}
        isConnectable={isConnectable}
      />
      <Add
        title="Add Condition"
        id={calloutId}
        onClick={() => {
          setVisibility(true);
          setNodeScrollState(false);
        }}
      />

      <FormView
        onSave={handleAddCondition}
        approvalTypes={approvalTypes}
        onClose={() => {
          setNodeScrollState(true);
          setVisibility(false);
        }}
        visibility={visibility}
      />
    </Stack>
  );
};
